module.exports = __webpack_public_path__ + "static/img/feature_3.d51ca12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/surveys/feature_3.png
// module id = y27z
// module chunks = 0